import React from "react";
import { CardHeader } from "../../../../../components/cards";
import { TurnoverGraph } from "../../../../scans/components/graphs";
import { Loading } from "../../../../../components";

interface IProductStockVariations {
  data: any;
  loading: boolean;
}

export const ProductTurnover: React.FC<IProductStockVariations> = ({
  data,
  loading,
}) => {
  return (
    <>
      {loading ? <Loading /> : null}
      {data ? (
        <TurnoverGraph data={data} onSelect={(data) => console.log(data)} />
      ) : null}
    </>
  );
};
